import { capitalize } from 'lodash-es';

/**
 * @param  {string} str capitalizes the first letter of a string and lowercase for all the following letters
 */
export default function titleCase(str) {
  return capitalize(str);
}
